module.exports = __webpack_public_path__ + "static/media/link.b71261c5.svg";